import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GeneralProductsProducts } from 'src/app/services/service/DataProviders/GeneralProductsProducts';
import * as _ from "lodash";
import { LogisticsInventoryStores } from 'src/app/services/service/DataProviders/LogisticsInventoryStores';
import { Subject } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'substitude-define',
  templateUrl: './substitude-define.component.html',
  styleUrls: ['./substitude-define.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubstitudeDefineComponent implements OnInit {

  @Input() openModal: boolean = false;
  @Input() recipes: Array<any> = [];
  @Output() openModalChanged = new EventEmitter();

  @Input() substitudes: Array<any> = null;

  private default_subs = {
    source: {
      product: null,
      measure: null,
      productName: null,
      quantity: null,
    },
    replace: {
      product: null,
      measure: null,
      productName: null,
      quantity: null,
      storeName: null,
      store: null,
    },
    autoAdded: false,
  };

  // @Input() substitution = this.default_subs;
  // @Output() substitutionChanged = new EventEmitter();
  public substitution;
  public selectedSubstitution: any[] = [];

  @Output() saveFunction = new EventEmitter();

  public sourceProducts: any = [];
  public sourceLoadingProducts: boolean = false;
  public replaceProducts: any = [];
  public replaceLoadingProducts: boolean = false;
  public storeOptions = [];

  constructor(
    private productService: GeneralProductsProducts,
    private storeService: LogisticsInventoryStores,
    private settingService: SettingsService,
    private ref: ChangeDetectorRef,
    ) {
      this.resetSubs();
     }

  ngOnInit(): void {
    this.loadStores()
  }

  public editIndex = null;

  addEditSubs(subs) {
    if(subs != null) {
      this.editIndex = this.substitudes.indexOf(subs);
      this.substitution = subs;
    }

    this.openModal = true;
  }

  async fetchSourceProducts(e = '') {
    this.sourceLoadingProducts = true;
    if(_.isNull(e) || _.isEmpty(e) || typeof e === "undefined") {
      this.sourceLoadingProducts = false;
      return this.sourceProducts;
    }

    if(e.length < 3) {
      this.sourceLoadingProducts = false;
      return this.sourceProducts;
    }

    this.sourceProducts = await this.productService.filterByNameOrCode(e);
    this.sourceLoadingProducts = false;
    return this.sourceProducts;
  }

  async fetchReplaceProducts(e = '') {
    this.replaceLoadingProducts = true;
    if(_.isNull(e) || _.isEmpty(e) || typeof e === "undefined") {
      this.replaceLoadingProducts = false;
      return this.replaceProducts;
    }

    if(e.length < 3) {
      this.replaceLoadingProducts = false;
      return this.replaceProducts;
    }

    this.replaceProducts = await this.productService.filterByNameOrCode(e);
    this.replaceLoadingProducts = false;
    return this.replaceProducts;
  }

  loadStores() {
    let obz = new Subject();
    let call = JSON.parse(JSON.stringify(this.storeService.stateTemplate));
    call.take = 1000;
    this.storeService.filterStores(call)
    .subscribe((res: any) => {
      this.storeOptions = res.value;
      obz.next();
    });

    return obz.asObservable();
  }

  save() {
    this.openModal = false;
    if(_.isNull(this.editIndex)) {
      let sourceProduct = _.find(this.sourceProducts, (e) => e?.Name?.BG === this.substitution.source.productName) || null;
      let replaceProduct = _.find(this.replaceProducts, (e) => e?.Name?.BG === this.substitution.replace.productName) || null;

      this.substitution.source.productName = this.substitution.source.productName;
      this.substitution.source.product = sourceProduct;
      this.substitution.source.measure = sourceProduct?.MeasurementUnit ? sourceProduct.MeasurementUnit : null;
      this.substitution.source.productCode = sourceProduct?.PartNumber ? sourceProduct?.PartNumber : null;
      this.substitution.replace.productName = this.substitution.replace.productName;
      this.substitution.replace.product = replaceProduct;
      this.substitution.replace.measure = replaceProduct?.MeasurementUnit ? replaceProduct.MeasurementUnit : null;
      this.substitution.replace.storeName =this.substitution.replace.storeName;
      this.substitution.replace.store = _.find(this.storeOptions, (e) => e?.Name?.BG === this.substitution.replace.storeName) || null;
      this.substitution.replace.productCode = replaceProduct?.PartNumber ? replaceProduct?.PartNumber : null;
    }

    this.substitution.source.quantity = this.normalizeSourceQuantity(this.substitution.source.quantity);

    this.saveFunction.emit({
      subs: this.substitution,
      idx: this.editIndex,
    });
    this.resetSubs();
  }

  cancel() {
    this.openModal = false;
    this.resetSubs();
  }

  private normalizeSourceQuantity(quantity: any): number | null {
    if(_.isNull(quantity) || _.isUndefined(quantity) || quantity === '') {
      return null;
    }

    const parsedQuantity = Number(quantity);
    return Number.isFinite(parsedQuantity) ? parsedQuantity : null;
  }

  private resetSubs() {
    this.substitution = JSON.parse(JSON.stringify(this.default_subs));
    this.editIndex = null;
  }

  addFromRecipes() {
    for(let i = 0; i < this.recipes.length; i++) {
      for(let j = 0; j < this.recipes[i].Ingredients.length; j++) {
        let ing = this.recipes[i].Ingredients[j];

        this.substitution.source.productName = _.get(ing,'Material.Name.BG');
        this.substitution.source.product = _.get(ing,'Material');
        this.substitution.source.measure = _.get(ing,'UsageUnit');
        this.substitution.source.quantity = _.get(ing,'UsageQuantity.Value');
        this.substitution.source.productCode = _.get(ing,'Material.PartNumber');
        this.substitution.replace.productName = _.get(ing,'Material.Name.BG');
        this.substitution.replace.product = _.get(ing,'Material');
        this.substitution.replace.storeName = _.get(ing,'Store.Name.BG');
        this.substitution.replace.measure = _.get(ing,'UsageUnit');
        this.substitution.replace.store = _.get(ing,'Store');
        this.substitution.replace.quantity = _.get(ing,'UsageQuantity.Value');
        this.substitution.replace.productCode = _.get(ing,'Material.PartNumber');
        this.substitution.autoAdded = true;
        this.saveFunction.emit({
          subs: this.substitution,
          idx: null,
        });
        this.resetSubs();
      }
    }
  }

  removeSubstitude(subs) {
    _.remove(this.substitudes, e => _.isEqual(e, subs));
    this.settingService.setSubstitudes(this.substitudes);
  }

  removeSelected() {
    for(let i = 0; i < this.selectedSubstitution.length; i++) {
      this.removeSubstitude(this.selectedSubstitution[i]);
    }

    this.selectedSubstitution = [];
  }

}
